<template>
  <div style="margin-top: 18vh">
    <div class="spin cell auto"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Spinner',
})
</script>

<style lang="scss" scoped>
.spin {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6rem;
  height: 6rem;
  margin: 0 auto;
  border: 3px solid transparent;
  border-radius: 50%;
  border-top-color: $lighter-petrol;
  animation: spin 1s ease infinite;
}

@keyframes spin {
  to {
    transform: rotateZ(360deg);
  }
}
</style>
